<template>
<div class="container">
  <div class="login-wrap">

    <div class="img-wrap">
      <img src="/static/accountadmin/img_logo_green2.png"/>
      <div>Medtrum</div>
      <div> Management</div>
    </div>

    <div class="row2">
      <img src="/static/accountadmin/icon_user.png" />
      <input v-model="username" placeholder="E-mail"/>
    </div>

    <div class="row2 password">
      <img src="/static/accountadmin/icon_password.png" />
      <input v-model="password" placeholder="Password" type="password"/>
    </div>

    <p class="error-tip">
      {{errorTip}}
    </p>

    <div class="btn" @click="accountAdminLogin()">
      <p>Sign in</p>
    </div>

  </div>
  <div class="Hcp-footer">
      <span>
        <a :href="contactURL">{{ $t('contact us') }} </a>
        <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
        <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} </a>
      </span>
    </div>
</div> <!--container结束-->
</template>

<script>
  export default {
    data() {
      return {
        //errorTip:'Account not exists. ',
        username:'',
        password:'',
        errorTip:'',
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    computed:{

    },
    watch:{

    },
    mounted(){
      this.contactURL = 'https://www.medtrum.com/contact.html';
      this.privacyURL = 'https://www.medtrum.com/contact.html';
      this.termsOfUseURL = 'https://www.medtrum.com/contact.html';
    },
    created() {
    let that = this;
    document.onkeydown =function(e){
      e = window.event || e;
      if((e.code==='Enter'||e.code==='enter'||e.code==='NumpadEnter')&&that.$route.path==='/managementtools'&&!e.isComposing){//验证在登录界面和按得键是回车键enter
        that.accountAdminLogin();//登录函数
        }
      }
    },
    methods: {
      accountAdminLogin(){
        this.$http.post('/api/v2.0/login', {
            user_name:this.username,
            user_type:'P',
            password:this.password,
            flag:'account_admin_login'
        }).then(function (res) {
          // console.log('account admin login:', res.body)
          let errorCode=res.body.error;
          if (2==errorCode) {
            // this.errorTip = 'Account not exist.'
            this.$message.error('Account not exist.')
          } else if (errorCode) {
            // this.errorTip = 'Login fail';
            this.$message.error('Login fail.')
          } else {
            //alert('Login Success.')
            let role = res.body.role;
            sessionStorage.setItem('token','Header:'+res.bodyText);
            sessionStorage.setItem('account_admin_username', res.body.username)
            sessionStorage.setItem('uid', res.body.uid)
            sessionStorage.setItem('role',role)
            if ('AccountAdminSuper' == role) {
              this.$router.push('/accountsadmin_super')
            } else if ('AccountAdmin'==role||'AgencyAccountAdmin'==role) {
              sessionStorage.setItem('account_admin_permission', JSON.stringify(res.body.permission));
              this.$router.push('/accountsadmin_home')
            }
          }
        }, function (err) {
          
        })
      }
    },
  }
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#0c544f;
  }

  .login-wrap {
    width:440px;
    height:276px;
    background-color:#ffffff;
    border-radius:8px;
    position: relative;
    top: 50%; /*偏移*/
    transform: translateY(-50%);
    margin:0 auto;
  }
  .login-wrap .img-wrap {
    padding-top: 14px;
    display: flex;
    align-items: center;
  }
  .login-wrap .img-wrap img {
    margin-left: 50px;
    display: block;
    *margin-top: 24px;
    width: 40px;
    height: 40px;
  }
  .login-wrap .img-wrap div {
    margin-left: 10px;
    font-size: 20px;
    color: #0c544f;
    font-weight: 600;
  }

  .login-wrap .row2 {
    width:329px;
    margin: 0 auto;
    height:35px;
    border-bottom: solid 1px #0c544f;
    margin-top:25px;
  }

  .login-wrap .error-tip {
    width:329px;
    margin: 0 auto;
    color:#c03c13;
    font-size:16px;
    margin-top: 10px;
    height:20px;
  }

  .login-wrap .row2.password {
    margin-top:10px;
  }

  .login-wrap .row2 img {
    float: left;
  }

  .login-wrap .row2 input {
    height: 25px;
    width:260px;
    *float:left;
    margin-top:5px;
    margin-left:10px;
    border:none;
    font-size:18px;
  }

  .login-wrap .row2 input:focus {
    outline:none;
  }

  .login-wrap .btn {
    width:150px;
    height:30px;
    border-radius: 30px;
    background-color:#0c544f;
    margin: 0 auto;
    margin-top:30px;
    cursor: pointer;
  }

  .login-wrap .btn:hover {
    background-color:#0c624f;
  }

  .login-wrap .btn p {
    color: #fff;
    font-size:18px;
    line-height: 30px;
    text-align: center;
  }
  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 23px;
    *margin-bottom: 10px;
    margin-left: 1240px;
    position: relative;
    top: 60%; /*偏移*/
    transform: translateY(-50%);
  }
  .Hcp-footer a{
    color:#fff;
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }
</style>



// WEBPACK FOOTER //
// LoginAccountAdmin.vue?f47b8912